var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-row',[_c('v-col',{attrs:{"xs":"12","md":"6"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"full-width":"","max-width":"290"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"value":_vm.formatedScheduleDate,"clearable":"","label":"Data de agendamento","readonly":"","prepend-icon":"event"},on:{"click:clear":function($event){_vm.schedule_date = null}}},on))]}}]),model:{value:(_vm.schedule_date_menu),callback:function ($$v) {_vm.schedule_date_menu=$$v},expression:"schedule_date_menu"}},[_c('v-date-picker',{attrs:{"required":"","min":_vm.minScheduleDate,"locale":"pt-br"},on:{"change":function($event){_vm.schedule_date_menu = false}},model:{value:(_vm.schedule_date),callback:function ($$v) {_vm.schedule_date=$$v},expression:"schedule_date"}})],1)],1),_c('v-col',{attrs:{"xs":"12","md":"6"}},[_c('v-select',{attrs:{"required":"","items":[
            {
            text: 'Aguardando Contato',
            value: 1,
            },
            {
            text: 'Contactado por WhatsApp',
            value: 2,
            },
            {
            text: 'Contactado por Telefone',
            value: 3,
            },
            {
            text: 'Contactado por SMS',
            value: 4,
            },
            {
            text: 'Contactado por E-mail',
            value: 5,
            },
            {
            text: 'Agendado',
            value: 6,
            },
            {
            text: 'Sem WhatsApp',
            value: 7,
            },
            {
            text: 'Não Responde',
            value: 8,
            },
            {
            text: 'Não Comprou',
            value: 9,
            },
            {
            text: 'Rastreio Enviado',
            value: 10,
            } ],"label":"Status"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"xs":"12"}},[_c('v-textarea',{attrs:{"solo":"","name":"observations","label":"Observações","required":"","no-resize":""},model:{value:(_vm.observations),callback:function ($$v) {_vm.observations=$$v},expression:"observations"}})],1)],1),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"success","type":"submit"}},[_vm._v("\n    "+_vm._s(this.selected ? 'Atualizar' : 'Cadastrar')+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }